var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleplayImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 40,
    viewBox: "0 0 141 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135.778 40H5.22222C2.35 40 0 37.75 0 35V5C0 2.25 2.35 2.86102e-06 5.22222 2.86102e-06H135.778C138.65 2.86102e-06 141 2.25 141 5V35C141 37.75 138.65 40 135.778 40Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M135.778 2.86102e-06H5.22222C2.35 2.86102e-06 0 2.25 0 5V35C0 37.75 2.35 40 5.22222 40H135.778C138.65 40 141 37.75 141 35V5C141 2.25 138.65 2.86102e-06 135.778 2.86102e-06ZM135.778 0.800002C138.197 0.800002 140.164 2.6844 140.164 5V35C140.164 37.316 138.197 39.2004 135.778 39.2004H5.22222C2.80371 39.2004 0.835556 37.316 0.835556 35V5C0.835556 2.6844 2.80371 0.800002 5.22222 0.800002H135.778Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M111.689 29.9995H113.638V17.4983H111.689V29.9995ZM129.243 22.0015L127.009 27.4214H126.942L124.623 22.0015H122.524L126.001 29.5768L124.019 33.7905H126.052L131.41 22.0015H129.243ZM118.191 28.5796C117.552 28.5796 116.662 28.2741 116.662 27.5179C116.662 26.553 117.771 26.1831 118.728 26.1831C119.585 26.1831 119.987 26.36 120.508 26.6015C120.357 27.7593 119.316 28.5796 118.191 28.5796ZM118.426 21.728C117.015 21.728 115.554 22.3233 114.949 23.6421L116.678 24.3335C117.048 23.6421 117.736 23.4167 118.459 23.4167C119.467 23.4167 120.492 23.996 120.508 25.0253V25.1538C120.155 24.9608 119.4 24.6714 118.476 24.6714C116.612 24.6714 114.713 25.6522 114.713 27.4858C114.713 29.1585 116.242 30.2362 117.955 30.2362C119.265 30.2362 119.987 29.6733 120.442 29.014H120.508V29.9788H122.389V25.1858C122.389 22.9667 120.66 21.728 118.426 21.728ZM106.381 23.5233H103.609V19.2382H106.381C107.838 19.2382 108.665 20.3932 108.665 21.3807C108.665 22.3495 107.838 23.5233 106.381 23.5233ZM106.331 17.4983H101.661V29.9995H103.609V25.2632H106.331C108.491 25.2632 110.614 23.7659 110.614 21.3807C110.614 18.9956 108.491 17.4983 106.331 17.4983ZM80.8665 28.5819C79.5201 28.5819 78.3928 27.5026 78.3928 26.0202C78.3928 24.5222 79.5201 23.4265 80.8665 23.4265C82.1957 23.4265 83.2389 24.5222 83.2389 26.0202C83.2389 27.5026 82.1957 28.5819 80.8665 28.5819ZM83.1043 22.7015H83.0369C82.5996 22.2022 81.7579 21.7511 80.698 21.7511C78.4769 21.7511 76.441 23.6198 76.441 26.0202C76.441 28.4046 78.4769 30.2573 80.698 30.2573C81.7579 30.2573 82.5996 29.8061 83.0369 29.2909H83.1043V29.903C83.1043 31.5304 82.1957 32.4003 80.7318 32.4003C79.5372 32.4003 78.7968 31.5784 78.4936 30.8858L76.7944 31.5624C77.2824 32.6901 78.5781 34.0757 80.7318 34.0757C83.0202 34.0757 84.9553 32.7866 84.9553 29.6452V22.0089H83.1043V22.7015ZM86.3012 29.9995H88.2531V17.4979H86.3012V29.9995ZM91.1305 25.8753C91.08 24.2319 92.4598 23.3944 93.4524 23.3944C94.227 23.3944 94.8829 23.7647 95.1012 24.2968L91.1305 25.8753ZM97.188 24.4577C96.8183 23.5069 95.6903 21.7511 93.3851 21.7511C91.0967 21.7511 89.1955 23.4749 89.1955 26.0042C89.1955 28.3886 91.08 30.2573 93.6038 30.2573C95.6401 30.2573 96.8183 29.0651 97.306 28.3725L95.7916 27.4057C95.2871 28.1147 94.5967 28.5819 93.6038 28.5819C92.6111 28.5819 91.9046 28.1468 91.45 27.2932L97.3896 24.9409L97.188 24.4577ZM49.8661 23.0561V24.8604H54.3755C54.2409 25.8753 53.8875 26.6163 53.349 27.1319C52.693 27.7604 51.6665 28.453 49.8661 28.453C47.0897 28.453 44.9192 26.3104 44.9192 23.6522C44.9192 20.994 47.0897 18.8511 49.8661 18.8511C51.3637 18.8511 52.4572 19.4151 53.2649 20.1401L54.5942 18.8675C53.4669 17.8362 51.9692 17.0468 49.8661 17.0468C46.0632 17.0468 42.8662 20.0112 42.8662 23.6522C42.8662 27.2932 46.0632 30.2573 49.8661 30.2573C51.9191 30.2573 53.4669 29.6132 54.6783 28.4046C55.9235 27.2124 56.3106 25.537 56.3106 24.1839C56.3106 23.7647 56.2771 23.3784 56.2094 23.0561H49.8661ZM61.4374 28.5819C60.091 28.5819 58.9299 27.5186 58.9299 26.0042C58.9299 24.4737 60.091 23.4265 61.4374 23.4265C62.7833 23.4265 63.9444 24.4737 63.9444 26.0042C63.9444 27.5186 62.7833 28.5819 61.4374 28.5819ZM61.4374 21.7511C58.9804 21.7511 56.978 23.5393 56.978 26.0042C56.978 28.453 58.9804 30.2573 61.4374 30.2573C63.8938 30.2573 65.8962 28.453 65.8962 26.0042C65.8962 23.5393 63.8938 21.7511 61.4374 21.7511ZM71.1645 28.5819C69.8187 28.5819 68.6574 27.5186 68.6574 26.0042C68.6574 24.4737 69.8187 23.4265 71.1645 23.4265C72.5105 23.4265 73.6716 24.4737 73.6716 26.0042C73.6716 27.5186 72.5105 28.5819 71.1645 28.5819ZM71.1645 21.7511C68.7077 21.7511 66.7057 23.5393 66.7057 26.0042C66.7057 28.453 68.7077 30.2573 71.1645 30.2573C73.6211 30.2573 75.6235 28.453 75.6235 26.0042C75.6235 23.5393 73.6211 21.7511 71.1645 21.7511Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9768 32.3892L10.8992 32.3181C10.5952 32.0102 10.4158 31.5321 10.4158 30.913V31.0587V8.94272C10.4158 8.94072 10.4158 8.93922 10.4158 8.93762C10.4158 8.93952 10.4158 8.94112 10.4158 8.94312V9.08922C10.4158 8.41882 10.625 7.91383 10.9755 7.61102L23.916 20.0005L10.9768 32.3892ZM10.4158 8.93643C10.4158 8.88132 10.4174 8.82782 10.4203 8.77512C10.4174 8.82742 10.4158 8.88132 10.4158 8.93643ZM10.4203 8.77273C10.4203 8.77203 10.4203 8.77122 10.4206 8.77042C10.4203 8.77122 10.4203 8.77203 10.4203 8.77273ZM10.4206 8.76572C10.4206 8.76533 10.4206 8.76492 10.4206 8.76453C10.4206 8.76492 10.4206 8.76533 10.4206 8.76572Z",
    fill: "url(#paint0_linear_2_343)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2288 24.2793L28.3272 24.2258L33.4376 21.4457C33.9248 21.1805 34.2495 20.859 34.4115 20.5188C34.25 20.859 33.9251 21.1809 33.4376 21.4461L28.3272 24.2262L28.2288 24.2793ZM28.2301 24.1328L23.916 20.0016L28.2297 15.8711L33.4376 18.7039C34.0989 19.0637 34.4702 19.5274 34.5323 20.0012C34.5323 20.0016 34.5323 20.0024 34.5323 20.0031C34.4702 20.4758 34.0989 20.9399 33.4376 21.2996L28.2301 24.1328Z",
    fill: "url(#paint1_linear_2_343)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8986 32.8605C11.5371 32.8605 11.2217 32.748 10.9757 32.5355L10.9762 32.5351C11.2221 32.7476 11.538 32.8605 11.8994 32.8605C11.9308 32.8605 11.9626 32.8597 11.9949 32.8582C11.9622 32.8597 11.9299 32.8605 11.8986 32.8605ZM11.899 32.714C11.5375 32.7144 11.2221 32.6015 10.9762 32.389V32.3887L23.9154 20L28.2294 24.1312L13.0691 32.3785C12.6497 32.6062 12.2523 32.714 11.899 32.714ZM10.9725 32.5328C10.9496 32.5129 10.9272 32.4918 10.9051 32.4699L10.9725 32.5328Z",
    fill: "url(#paint2_linear_2_343)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9161 20.0008L10.9756 7.6113C11.2216 7.3992 11.5366 7.2867 11.8976 7.2867C12.2518 7.2867 12.6495 7.3949 13.0698 7.623L28.2297 15.8703L23.9161 20.0008ZM28.3273 15.777L13.0698 7.47699C12.6495 7.24879 12.2518 7.1406 11.8976 7.1406C11.896 7.1406 11.8948 7.1406 11.8931 7.1406C11.8952 7.1406 11.8968 7.1406 11.8993 7.1406C12.2526 7.1406 12.6499 7.24839 13.0698 7.47659L28.3273 15.777Z",
    fill: "url(#paint3_linear_2_343)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9956 32.8601C12.324 32.8421 12.6875 32.7338 13.0698 32.5264L28.2289 24.2795L13.0698 32.5264C12.6878 32.7342 12.324 32.8421 11.9956 32.8601ZM10.9764 32.5373L10.9732 32.5346C10.9743 32.5354 10.9756 32.5365 10.9764 32.5373ZM10.9058 32.4717L10.8992 32.4655V32.4651C10.9017 32.4674 10.9037 32.4697 10.9058 32.4717Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2287 24.2784L28.3271 24.2249L28.2287 24.2784Z",
    fill: "url(#paint4_linear_2_343)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9001 32.8621C11.5386 32.8621 11.2228 32.7492 10.9768 32.5367L10.9764 32.5371C10.9756 32.5363 10.9743 32.5352 10.9732 32.5344L10.9058 32.4715C10.9037 32.4695 10.9017 32.4672 10.8992 32.4649L10.9768 32.3906C11.2228 32.6031 11.5382 32.716 11.8997 32.7156C12.2529 32.7156 12.6503 32.6078 13.0698 32.3801L28.2301 24.1328L28.3273 24.2258L28.2289 24.2793L13.0698 32.5262C12.6875 32.7336 12.324 32.8418 11.9956 32.8598C11.9633 32.8613 11.9315 32.8621 11.9001 32.8621Z",
    fill: "url(#paint5_linear_2_343)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8992 32.4641C10.5952 32.1562 10.4158 31.6781 10.4158 31.059V31.0586C10.4158 31.6781 10.5952 32.1558 10.8992 32.4637V32.4641Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8992 32.4648C10.5952 32.1569 10.4158 31.6792 10.4158 31.0597V30.914C10.4158 31.5331 10.5952 32.0112 10.8992 32.3191L10.9768 32.3902L10.8992 32.4648Z",
    fill: "url(#paint6_linear_2_343)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8992 32.4635L10.9768 32.3889V32.3892L10.8992 32.4635Z",
    fill: "url(#paint7_linear_2_343)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4112 20.5181C34.4915 20.3493 34.5319 20.1759 34.5319 20.0023C34.5319 20.002 34.5319 20.0016 34.5319 20.0016C34.5319 20.1755 34.4915 20.3489 34.4112 20.5181Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3277 24.2244L28.2306 24.1314L33.4381 21.2981C34.0994 20.9384 34.4707 20.4744 34.5327 20.0016C34.5327 20.1751 34.4923 20.3485 34.412 20.5173C34.25 20.8575 33.9253 21.1791 33.4381 21.4443L28.3277 24.2244Z",
    fill: "url(#paint8_linear_2_343)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M34.532 20.0011V20.0007C34.5316 19.4776 34.1664 18.9546 33.4373 18.5577L28.3269 15.7776H28.3265L28.3269 15.7773L33.4373 18.5573C34.1673 18.9542 34.5328 19.478 34.532 20.0011Z",
    fill: "#404040"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5318 20.0004C34.4698 19.5266 34.0985 19.0629 33.4372 18.7031L28.2292 15.8703L28.3264 15.7773H28.3268L33.4372 18.5574C34.1663 18.9543 34.5314 19.4773 34.5318 20.0004Z",
    fill: "url(#paint9_linear_2_343)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4158 8.9379C10.4158 8.9375 10.4158 8.9371 10.4158 8.9367C10.4158 8.9371 10.4158 8.9375 10.4158 8.9379ZM10.4203 8.7754C10.4203 8.7746 10.4203 8.7738 10.4203 8.773C10.4203 8.7738 10.4203 8.7746 10.4203 8.7754ZM10.4206 8.7707C10.4206 8.7691 10.4206 8.7676 10.4206 8.766C10.4206 8.7676 10.4206 8.7691 10.4206 8.7707ZM10.4206 8.7648C10.4811 7.7375 11.0645 7.1441 11.8898 7.1406C11.532 7.1426 11.2203 7.2551 10.9763 7.4656V7.4652L10.9734 7.468C10.9477 7.4902 10.9233 7.5137 10.8992 7.5379C10.625 7.8156 10.452 8.2316 10.4206 8.7648Z",
    fill: "#404040"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4158 9.08913V8.94303C10.4158 8.94103 10.4158 8.93943 10.4158 8.93753C10.4158 8.93713 10.4158 8.93673 10.4158 8.93633C10.4158 8.88123 10.4174 8.82733 10.4203 8.77503C10.4203 8.77423 10.4203 8.77343 10.4203 8.77263C10.4203 8.77193 10.4203 8.77113 10.4206 8.77033C10.4206 8.76873 10.4206 8.76723 10.4206 8.76563C10.4206 8.76523 10.4206 8.76483 10.4206 8.76443C10.452 8.23123 10.625 7.81523 10.8992 7.53753L10.9755 7.61093C10.625 7.91373 10.4158 8.41873 10.4158 9.08913ZM10.9734 7.46763L10.9763 7.46483C10.9755 7.46603 10.9743 7.46683 10.9734 7.46763Z",
    fill: "url(#paint10_linear_2_343)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2297 15.8703L13.0698 7.623C12.6495 7.3949 12.2518 7.2867 11.8976 7.2867C11.5366 7.2867 11.2215 7.3992 10.9756 7.6113L10.8992 7.5379C10.9234 7.5137 10.9478 7.4902 10.9735 7.468C10.9743 7.4672 10.9756 7.4664 10.9764 7.4656C11.2204 7.2551 11.5321 7.1426 11.8899 7.1406C11.8907 7.1406 11.8919 7.1406 11.8931 7.1406C11.8948 7.1406 11.8959 7.1406 11.8976 7.1406C12.2518 7.1406 12.6495 7.2488 13.0698 7.477L28.3273 15.777L28.3268 15.7773L28.2297 15.8703Z",
    fill: "url(#paint11_linear_2_343)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3646 8.36326V14H45.4412C47.1956 14 48.2278 12.9531 48.2278 11.1719C48.2278 9.39451 47.1915 8.36326 45.4412 8.36326H43.3646ZM44.2785 9.11717H45.3556C46.5999 9.11717 47.2934 9.85154 47.2934 11.1797C47.2934 12.5117 46.604 13.2422 45.3556 13.2422H44.2785V9.11717ZM49.274 14H50.1552V9.8906H49.274V14ZM49.7147 9.28904C50.0002 9.28904 50.2288 9.0742 50.2288 8.80857C50.2288 8.53514 50.0002 8.3242 49.7147 8.3242C49.4331 8.3242 49.2047 8.53514 49.2047 8.80857C49.2047 9.0742 49.4331 9.28904 49.7147 9.28904ZM51.2301 11.0664C51.2301 11.6367 51.6217 12.0156 52.3969 12.1953L53.164 12.375C53.6128 12.4844 53.7759 12.6211 53.7759 12.875C53.7759 13.2031 53.4454 13.4102 52.9191 13.4102C52.3847 13.4102 52.0542 13.1992 51.993 12.8047H51.1199C51.1852 13.5547 51.8665 14.0508 52.8783 14.0508C53.9268 14.0508 54.6613 13.543 54.6613 12.8008C54.6613 12.1992 54.3349 11.8945 53.4699 11.6953L52.7477 11.5352C52.3031 11.4297 52.0909 11.2656 52.0909 11.0195C52.0909 10.6992 52.4091 10.4883 52.8865 10.4883C53.3761 10.4883 53.6984 10.7109 53.7352 11.0742H54.5633C54.5429 10.3477 53.8615 9.84373 52.911 9.84373C51.9115 9.84373 51.2301 10.3398 51.2301 11.0664ZM57.833 9.84764C57.2333 9.84764 56.7111 10.1328 56.4664 10.5742H56.45V9.8906H55.5973V15.3594H56.4786V13.3242H56.499C56.7519 13.7812 57.2374 14.043 57.8494 14.043C58.9265 14.043 59.6404 13.2227 59.6404 11.9453C59.6404 10.6719 58.9224 9.84764 57.833 9.84764ZM57.6005 13.3281C56.9274 13.3281 56.4745 12.7734 56.4745 11.9453C56.4745 11.125 56.9274 10.5664 57.6005 10.5664C58.2859 10.5664 58.7347 11.1133 58.7347 11.9453C58.7347 12.7852 58.2859 13.3281 57.6005 13.3281ZM62.4166 14.0508C63.665 14.0508 64.4524 13.2422 64.4524 11.9453C64.4524 10.6523 63.6609 9.83982 62.4166 9.83982C61.1763 9.83982 60.3808 10.6523 60.3808 11.9453C60.3808 13.2422 61.1682 14.0508 62.4166 14.0508ZM62.4166 13.3555C61.7026 13.3555 61.2782 12.8359 61.2782 11.9453C61.2782 11.0625 61.7026 10.5352 62.4166 10.5352C63.1306 10.5352 63.5548 11.0586 63.5548 11.9453C63.5548 12.8359 63.1306 13.3555 62.4166 13.3555ZM65.3844 14H66.2657V11.6328C66.2657 11 66.6492 10.5703 67.2816 10.5703C67.9017 10.5703 68.1996 10.9141 68.1996 11.5312V14H69.0848V11.3672C69.0848 10.4258 68.5422 9.84373 67.5957 9.84373C66.9347 9.84373 66.5023 10.0977 66.2453 10.5898H66.2248V9.8906H65.3844V14ZM70.2168 14H71.098V9.8906H70.2168V14ZM70.6574 9.28904C70.943 9.28904 71.1714 9.0742 71.1714 8.80857C71.1714 8.53514 70.943 8.3242 70.6574 8.3242C70.3759 8.3242 70.1475 8.53514 70.1475 8.80857C70.1475 9.0742 70.3759 9.28904 70.6574 9.28904ZM74.5351 14.043C75.6203 14.043 76.3261 13.2227 76.3261 11.9453C76.3261 10.6719 75.6203 9.84764 74.5391 9.84764C73.9313 9.84764 73.4416 10.1133 73.1846 10.5742H73.1642V8.36326H72.2829V14H73.1398V13.3008H73.1561C73.4213 13.7773 73.9067 14.043 74.5351 14.043ZM74.2984 10.5664C74.9757 10.5664 75.4204 11.1094 75.4204 11.9453C75.4204 12.7891 74.9757 13.3281 74.2984 13.3281C73.6171 13.3281 73.1602 12.7734 73.1602 11.9453C73.1602 11.125 73.6212 10.5664 74.2984 10.5664ZM77.2948 14H78.1761V9.8906H77.2948V14ZM77.7354 9.28904C78.021 9.28904 78.2495 9.0742 78.2495 8.80857C78.2495 8.53514 78.021 8.3242 77.7354 8.3242C77.454 8.3242 77.2254 8.53514 77.2254 8.80857C77.2254 9.0742 77.454 9.28904 77.7354 9.28904ZM79.361 14H80.2423V8.36326H79.361V14ZM83.1938 10.5234C83.8058 10.5234 84.226 10.9375 84.2464 11.5664H82.1004C82.1453 10.9453 82.5859 10.5234 83.1938 10.5234ZM84.2423 12.793C84.124 13.1484 83.7405 13.3711 83.2509 13.3711C82.5573 13.3711 82.0963 12.9102 82.0963 12.207V12.1562H85.1277V11.8672C85.1277 10.6211 84.381 9.83982 83.1938 9.83982C81.9862 9.83982 81.207 10.6758 81.207 11.9648C81.207 13.25 81.9822 14.0508 83.2306 14.0508C84.2016 14.0508 84.9604 13.5391 85.0787 12.793H84.2423ZM87.9341 11.0664C87.9341 11.6367 88.3258 12.0156 89.101 12.1953L89.868 12.375C90.3168 12.4844 90.48 12.6211 90.48 12.875C90.48 13.2031 90.1495 13.4102 89.6232 13.4102C89.0888 13.4102 88.7583 13.1992 88.6971 12.8047H87.8239C87.8892 13.5547 88.5706 14.0508 89.5824 14.0508C90.6309 14.0508 91.3653 13.543 91.3653 12.8008C91.3653 12.1992 91.0389 11.8945 90.1739 11.6953L89.4518 11.5352C89.0071 11.4297 88.795 11.2656 88.795 11.0195C88.795 10.6992 89.1132 10.4883 89.5905 10.4883C90.0801 10.4883 90.4025 10.7109 90.4391 11.0742H91.2674C91.247 10.3477 90.5656 9.84373 89.6151 9.84373C88.6154 9.84373 87.9341 10.3398 87.9341 11.0664ZM95.9814 9.8906H95.1002V12.2578C95.1002 12.8984 94.7166 13.3203 94.0802 13.3203C93.4723 13.3203 93.1622 12.9883 93.1622 12.3633V9.8906H92.281V12.5273C92.281 13.4688 92.8521 14.0469 93.7865 14.0469C94.4433 14.0469 94.8716 13.7852 95.1165 13.293H95.1368V14H95.9814V9.8906Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_343",
    x1: 22.7685,
    y1: 8.70942,
    x2: 6.00189,
    y2: 26.2212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_343",
    x1: 35.3381,
    y1: 20.0022,
    x2: 10.0657,
    y2: 20.0022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_343",
    x1: 25.9297,
    y1: 22.2953,
    x2: 3.19288,
    y2: 46.0426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_343",
    x1: 7.62157,
    y1: 0.176198,
    x2: 17.7745,
    y2: 10.7803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_343",
    x1: 35.3376,
    y1: 20.0017,
    x2: 10.0662,
    y2: 20.0017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#CC9700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#CC8400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2_343",
    x1: 25.9304,
    y1: 22.2969,
    x2: 3.19358,
    y2: 46.0442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC2E36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C0E4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2_343",
    x1: 22.7685,
    y1: 8.7104,
    x2: 6.00184,
    y2: 26.2222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008DE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    stopColor: "#008DE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00A7E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00B8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00C4E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C7E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2_343",
    x1: 25.9309,
    y1: 22.296,
    x2: 3.19522,
    y2: 46.0441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0333C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB0F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2_343",
    x1: 35.3385,
    y1: 20.0007,
    x2: 10.0661,
    y2: 20.0007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0C500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#E0A600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#E09100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E08900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2_343",
    x1: 35.3376,
    y1: 20.0014,
    x2: 10.0652,
    y2: 20.0014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFCE40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFBC40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB540"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2_343",
    x1: 22.7685,
    y1: 8.70933,
    x2: 6.00185,
    y2: 26.2211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    stopColor: "#40B9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#40CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#40DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#40E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40EAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2_343",
    x1: 7.62155,
    y1: 0.176202,
    x2: 17.7745,
    y2: 10.7803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65B895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#62BD95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#50DB97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#44ED98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F498"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplayImg);
export default __webpack_public_path__ + "static/media/googleplayImg.81752856b68f223af3fb07fbb22e27b3.svg";
export { ForwardRef as ReactComponent };